import React, {FC} from 'react'
import {PageLink} from '../../../_metronic/layout/core'
import {KTCard} from '../../../_metronic/helpers'
import {Domain} from './Domain'
import {DomainPageTitle} from '_metronic/layout/core/DomainPageData'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const DomainWrapper: FC = () => {
  return (
    <>
      <DomainPageTitle
        icon='Icon-3.svg'
        title='Domains'
        // desc={totalVendor.toString() + ' Vendors'}
        desc={'1 connected domain'}
        breadcrumbs={usersBreadcrumbs}
      >
        Domains
      </DomainPageTitle>
      <KTCard>
        <Domain className='card-xl-stretch mb-xl-8' />
      </KTCard>
    </>
  )
}

export default DomainWrapper
